import { createGlobalStyle, css, FlattenSimpleInterpolation } from 'styled-components';

export const MachineOperatingHoursDashboardChartGlobalStyles = createGlobalStyle`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    .machine-operating-hours-dashboard-chart__pagination {
      position: absolute;
      width: calc(100% - 4px);
      left: 2px;
      top: 58px;
      bottom: unset;
      height: 64px;
      background-image: linear-gradient(${kcc.colors.WHITE}E6, ${kcc.colors.WHITE}00);
      z-index: 1;

      display: flex;
      align-items: flex-start;
      justify-content: center;

      &--disabled {
        display: none;
      }

      &:has(.machine-operating-hours-dashboard-chart__pagination-button--next) {
        background-image: linear-gradient(${kcc.colors.WHITE}00, ${kcc.colors.WHITE}E6);
        top: unset;
        bottom: 12px;
      }

      .machine-operating-hours-dashboard-chart__pagination-container {
        display: flex;
        justify-content: center;
        align-items: center;

        &:has(.machine-operating-hours-dashboard-chart__pagination-button--next) {
          background-image: linear-gradient(${kcc.colors.WHITE}00, ${kcc.colors.WHITE}E6);
          top: unset;
          bottom: 12px;
          align-self: flex-end;
        }
      }
    }
  `}
`;
